// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-list[data-v-c3475486]{overflow:auto;padding:0 1.5rem}.blue-card[data-v-c3475486]{margin-bottom:1.5rem}[data-v-c3475486] .v-app-bar-title__content{width:100%!important}.back-btn[data-v-c3475486]{color:#46aff2}", ""]);
// Exports
module.exports = exports;
